import TextHelper from './../../../utils/text'
import {addZero, timeFormatter} from '../../../utils/date'
import {useSelector} from 'react-redux'
import {CheckIcon, HelpIcon} from '../../../icons'
import {locationManager} from '../../../utils/locations'
import Tooltip from '../../core/tooltip'
import Table from './../../core/table'
import {routes} from '../../../routes'
import LimitManager from '../../../utils/limitManager'
import {colors} from '../../../utils/colors'
import NavigationHelper from '../../../utils/navigation'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'
import localStorageKeys from '../../../utils/localStorageKeys'

const LogsTable = () => {
    const data = useSelector(state => state.monitoring.resourceLogs)
    const lang = localStorage.getItem(localStorageKeys.LANGUAGE)
    const text = useNamespaceTranslations('monitoring')
    const usageLimitsData = useNamespaceTranslations('usage-limits')
    const tableHeader = [
        {label: text.date, className: 'min-width'},
        {label: text.status, className: 'min-width'},
        {label: text.change_label, className: 'log-change-header'},
        {label: text.location, className: 'min-width'},
        {label: text.duration, className: 'min-width'}
    ]

    const tbodyData = []

    const generateConvertedDate = time => {
        const date = new Date(Date.parse(time))

        return (
            <span className="min-width date">
                <span
                    className="checked-at">{[addZero(date.getHours()), addZero(date.getMinutes())].join(':')}</span>
                <span>{[date.getFullYear(), addZero(date.getMonth() + 1), addZero(date.getDate())].join('.')}</span>
            </span>
        )
    }

    const generateLogChange = state => {
        return (
            <span className="log-change-header log-change">
                <span className="log-text">{text.change_message}</span>
                {lang === 'en' ? <>
                    <span>{text.from}</span>
                    <span
                        className={`${TextHelper.getResourceState(state, ['down', 'up'])} up-down`}>{TextHelper.getResourceState(state, [text.down, text.up])}</span>
                    <span>{text.to}</span>
                    <span className={`${TextHelper.getResourceState(state, ['up', 'down'])} up-down`}>{TextHelper.getResourceState(state, [text.up, text.down])}</span>

                </> :
                    <>
                        <span
                            className={`${TextHelper.getResourceState(state, ['down', 'up'])} up-down`}>{TextHelper.getResourceState(state, [text.down, text.up])}</span>
                        <span>{text.from}</span>
                        <span
                            className={`${TextHelper.getResourceState(state, ['up', 'down'])} up-down`}>{TextHelper.getResourceState(state, [text.up, text.down])}</span>
                        <span>{text.to}</span>
                        <span>{text.changed}</span>
                    </>}

            </span>
        )
    }

    const generateLogDuration = duration => {
        const message = duration === 0 ?  text.not_available : timeFormatter(duration)?.formatted

        return <span className="min-width duration">{message}</span>
    }

    const generateLogDescription = description => {
        return !LimitManager.getStateDescIsEnabled(usageLimitsData) ?
            `<span>${description}</span><a href=${NavigationHelper.getLocalizedPath(routes.plans.paths)}>${text.upgrade_plan}</a>` :
            `<span>${description}</span>`
    }

    const generateLogStatus = log => {
        return (
            <div className="min-width log-status">
                <span>
                    {log?.status}
                </span>
                {log?.description &&
                    <span>
                        <Tooltip
                            trigger="click"
                            content={<span dangerouslySetInnerHTML={{__html: generateLogDescription(log?.description)}}/>}
                            interactive={true}
                        >
                            <HelpIcon stroke={colors.colorMuted} width="16" height="16"/>
                        </Tooltip>
                    </span>}
            </div>
        )
    }

    const getRegions = log => {
        let approvalRegion = log.approval_region ?

            <Tooltip content={locationManager.allLocations[log.approval_region]?.location}>
                {locationManager.allLocations[log.approval_region]?.icon}
            </Tooltip> : null
        return (
            <span className="min-width">
                <div className="region-container">
                    <Tooltip content={locationManager.allLocations[log.region]?.location}>
                        {locationManager.allLocations[log.region]?.icon}
                    </Tooltip>
                    {approvalRegion}
                    {approvalRegion && (
                        <span className="approval-region-info">
                            <Tooltip content={text.down_time_approved}>
                                <CheckIcon className="warning-icon tooltip-target"/>
                            </Tooltip>
                        </span>
                    )}
                </div>
            </span>
        )
    }

    data?.map(log => {
        tbodyData.push([
            generateConvertedDate(log.checked_at),
            generateLogStatus(log),
            generateLogChange(log.state),
            getRegions(log),
            generateLogDuration(log.down_duration)
        ])
    })
    return (
        data ? (
            <Table
                tableHeader={tableHeader}
                tbodyData={tbodyData}
                data={data}
                hasCheckbox={false}
                isMultiCheckable={false}
                isScrollable={data?.length > 10}
            />
        ) : <></>
    )
}

export default LogsTable
